import React from "react";
import {Modal, Form, Button} from "react-bootstrap";
import ModalBase from "./ModalBase";

import "../../../assets/sass/components/modals/finish-evaluation-modal.scss";

class FinishEvaluationModal extends ModalBase {
    
    renderBody = () => {
        const { avgScore } = this.props;

        return (
            <>
                <p className="text">Calculated Avg Score</p>
                <h3 className="score">{avgScore}</h3>
                <p className="text">Your Overall Comments and thoughts</p>
                <Form.Group controlId="overall-comment">
                    <Form.Control
                        as="textarea"
                        name="overallComment"
                        rows="3"
                        className="custom-textarea"
                        placeholder="Write Overall Comments and thoughts"
                    />
                </Form.Group>
            </>
        )
    };
    
    renderHeader = () => {
        const {headerTitle, headerSubtitle} = this.props;

        return (
            <React.Fragment>
                <Modal.Title className="title">{headerTitle}</Modal.Title>
                <Modal.Title className="subtitle">{headerSubtitle}</Modal.Title>
            </React.Fragment>
        );
    };

    renderFooter = () => {
        const { onSuccess, onHide } = this.props;

        return (
            <Button variant="primary" className="sm" onClick={() => {onSuccess(); onHide()}}>Finish and Save My Evaluation</Button>
        )
    };

    modalClassname = () => "finish-evaluation-modal";

    static defaultProps = {
        ...super.defaultProps,
        playerprofiletext: "View Player Profile"
    };
}

export default FinishEvaluationModal;
